<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="this.$parent.closePasswordReset">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <form :action="endpoint" method="POST" id="password-form">
                <input type="hidden" name="_token" v-bind:value="csrf_token">
                <div class="mt-3 text-center">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    Reset Password
                  </DialogTitle>
                  <div class="mt-2">
                      <div class="grid grid-cols-2 gap-3">

                          <div class="col-span-2 sm:col-span-1">
                              <label for="password" class="block text-sm font-medium text-gray-700">New Password</label>
                              <input type="password" name="password" id="password" v-model="password" v-on:keyup="checkConfirmation" class="appearance-none shadow-sm rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-uknar-primary focus:border-uknar-primary focus:z-10 sm:text-sm">
                          </div>

                          <div class="col-span-2 sm:col-span-1">
                              <label for="password_confirmation" class="block text-sm font-medium text-gray-700">Confirm New Password</label>
                              <input type="password" name="password_confirmation" id="password_confirmation" v-model="password_confirmation" v-on:keyup="checkConfirmation" class="appearance-none shadow-sm rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-uknar-primary focus:border-uknar-primary focus:z-10 sm:text-sm">
                          </div>

                      </div>
                  </div>
                  <div v-if="!passwords_match" class="grid grid-cols-4">
                      <div class="col-span-2 col-start-2">
                          <div class="max-w-50 mx-auto mt-5 py-2 px-2 rounded-lg bg-rose-600">
                              <div class="flex items-center justify-between flex-wrap">
                                  <div class="w-0 flex-1 flex items-center">
                                      <p class="ml-3 font-medium text-white truncate">
                                          <span>Passwords do not match!</span>
                                      </p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
              </form>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button type="button" :disabled="!passwords_match" v-on:click="submitForm" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:col-start-2 sm:text-sm">
                  Reset
                </button>
                <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:mt-0 sm:col-start-1 sm:text-sm" @click="this.$parent.closePasswordReset" ref="cancelButtonRef">
                  Cancel
                </button>
              </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { ref } from 'vue'
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon } from '@heroicons/vue/outline'

export default {
  props: {
      open: {
          type: Boolean,
          required: true,
          default: true
      },
      endpoint: {
          type: String,
          required: true,
      },
      csrf_token: {
          type: String,
          required: true
      }
  },
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    CheckIcon,
  },
  data: function () {
      return {
          password: null,
          password_confirmation: null,
          passwords_match: true
      };
  },
  methods: {
    checkConfirmation: function () {
        if (this.password_confirmation != this.password) {
            this.passwords_match = false;
        } else {
            this.passwords_match = true;
        }
    },
    submitForm: function () {
        if (!this.passwords_match) {
            return;
        }

        document.getElementById("password-form").submit();
    }
  }
}
</script>
